import { Box, Center, Flex, HStack, Link, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';

type NavActionProps = {
  href?: string;
  label: string;
  icon: ReactNode;
  isActive?: boolean;
  children?: ReactNode;
  onClick?: () => void;
};

const MobileNavAction = (props: NavActionProps) => {
  const { label, icon, isActive, children } = props;
  return (
    <Center onClick={props.onClick} height='56px' rounded='md' aria-current={isActive ? 'page' : undefined}>
      <Flex position='relative' direction='column' align='center' as='button' gap='1'>
        <Box fontSize='xl' color={isActive ? 'colorPalette.600' : 'gray.600'}>
          {icon}
        </Box>
        <Text fontSize='xs' fontWeight='medium' color={isActive ? 'colorPalette.600' : 'gray.600'}>
          {label}
        </Text>
        {children}
      </Flex>
    </Center>
  );
};

export const DesktopNavAction = (props: NavActionProps) => {
  const { label, icon, href = '#' } = props;
  return (
    <HStack gap='2'>
      <Link as='a' onClick={props.onClick} href={href} textDecoration={'none'}>
        <Text fontSize='sm' fontWeight='semibold'>
          {label}
        </Text>
        {icon}
      </Link>
    </HStack>
  );
};

export const NavAction = {
  Mobile: MobileNavAction,
  Desktop: DesktopNavAction
};
